<div id="todo" class="page-layout carded left-sidebar inner-scroll">

    <!-- SIDEBAR -->
    <fuse-sidebar class="sidebar" name="customer-cards-sidebar" position="left" lockedOpen="gt-md">
        <customer-details-sidebar [user]="user"></customer-details-sidebar>
    </fuse-sidebar>
    <!-- / SIDEBAR -->

<!--    <div id="changelog" class="page-layout simple fullwidth docs" style="overflow-y: scroll;">-->
        <!-- CONTENT -->
        <div class="content p-24" style="overflow-y: scroll;">

            <div class="changelog">
                <div class="entry" *ngFor="let log of logs">

                    <div class="title">
                        <span class="version red" *ngIf="log.errorLog">{{log.description|translate}}</span>
                        <span class="version" *ngIf="!log.errorLog">{{log.description|translate}}</span>
                        <span class="date">({{log.createdAt|date: 'dd.MM.y HH:mm:ss': 'UTC+2': locale}})</span>
                    </div>

                    <div class="groups">

                        <div class="new">
                        <span class="title">
                            {{'Additional info'|translate}}
                        </span>
                            <ul>
                                <li *ngFor="let log of log.params | keyvalue"
                                    [class.hidden]="log.key == 'cardUuid' || log.key == 'uuid' || log.key == 'serviceId'">
                                <span *ngIf="log.key === 'addedAt' || log.key === 'expirationDate'">
                                    <b>{{log.key|translate}}:</b> {{log.value|date: 'dd.MM.y HH:mm:ss': 'UTC+2': locale}}
                                </span>
                                    <span *ngIf="log.key !== 'addedAt' && log.key !== 'expirationDate'">
                                    <b>{{log.key|translate}}:</b> {{log.value}}
                                        <span *ngIf="log.value === '' && log.key === 'serviceName'">{{'All services'|translate}}</span>
                                </span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- / CONTENT -->
<!--    </div>-->
</div>
